export const customLayoutConfig = {
  layoutSlots: {
    footer: {
      slots: [],
    },
    SearchResultsListPageTemplate: {
      slots: ['SearchResultsListSlot', 'FooterSlot'],
    },
    ProductListPageTemplate: {
      slots: ['ProductListSlot', 'FooterSlot'],
    },
    MultiStepCheckoutSummaryPageTemplate: {
      slots: ['TopContent', 'BodyContent', 'SideContent'],
    },
    ProductDetailsPageTemplate: {
      slots: [
        'Summary',
        'UpSelling',
        'CrossSelling',
        'Sparepart',
        'Similar',
        'Accessories',
        'Tabs',
        'PlaceholderContentSlot',
      ],
    },
  },
};
